import { fromTable } from '@/integrations/supabase/db';
import { SearchResult, SearchSectionId } from '../types';
import { getMatchFunction, getServerPattern, getServerLimit, calculateRelevanceScore } from '../utils';

export async function searchZugaenge(
  term: string, 
  limit: number, 
  exactMatch: boolean,
  fuzzyMatch: boolean = false,
  signal?: AbortSignal
): Promise<SearchResult[]> {
  if (!term.trim()) return [];
  
  const pattern = getServerPattern(term, fuzzyMatch);
  const serverLimit = getServerLimit(limit, fuzzyMatch);
  const matchFn = getMatchFunction(exactMatch, fuzzyMatch);
  
  const { data, error } = await fromTable('access_credentials')
    .select('id, benutzername, beschreibung, link, gesellschaft_id, updated_at')
    .or(`benutzername.ilike.${pattern},beschreibung.ilike.${pattern},link.ilike.${pattern}`)
    .limit(serverLimit);

  if (error) {
    console.error('Zugänge search error:', error);
    return [];
  }

  return (data || [])
    .filter(z => matchFn(term, z.benutzername, z.beschreibung, z.link))
    .slice(0, limit)
    .map(z => {
      const title = z.benutzername || z.beschreibung || 'Zugang';
      const subtitle = z.link || undefined;
      
      return {
        id: z.id,
        type: 'zugaenge' as SearchSectionId,
        title,
        subtitle,
        badge: 'Zugang',
        data: z,
        relevanceScore: calculateRelevanceScore(term, title, subtitle, z.updated_at)
      };
    });
}
